<template>
  <div>
    <el-dialog
      title="确认分配"
      :visible.sync="dialogVisible"
      width="700px"
      top="15px"
      @open="open"
      @close="close"
    >
      <el-table :data="tableData" border style="width: 100%" show-summary
                :summary-method="getSummaries" :loading="isTableLoading"
      >
        <el-table-column fixed type="index" width="50" label="序号" align="left" />
        <el-table-column prop="contractNum" label="单据编号" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
        <el-table-column prop="amountSum" label="单据金额" align="right" header-align="left" width="" />
        <el-table-column prop="assignAmount" label="本次分配金额" align="right" header-align="left" width="" />
      </el-table>
      <div class="footer-btn">
        <el-button type="primary" :loading="isLoading" @click="submit">
          确认分配
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderAssignDealtContractToAssignInfoListTransfer } from '@/API/index.js';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      tableData: [],
      isTableLoading: false,
      isLoading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
  },
  methods: {
    initData () {
    },
    open () {
      this.tableData = this.data.dialogData;
      this.sureData = this.data;
    },
    close () {
      this.tableData = [];
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.AssignAmount();
        }
      });
      return sums;
    },
    AssignAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += item.assignAmount;
      });
      return cont;
    },
    // 确认分配按钮
    submit () {
      if (this.tableData.length === 0) {
        this.$message.error('请输入分配金额');
        return;
      }
      let assignInfoListVOList = [];
      this.sureData.dialogData.forEach((item) => {
        assignInfoListVOList.push({
          telegraphicTransferNum: item.telegraphicTransferNum,
          assignAmount: item.assignAmount
        });
      });
      let params = {
        id: this.sureData.contractId,
        contractNum: this.$route.query.contractNum,
        assignInfoListVOList: assignInfoListVOList
      };
      this.isLoading = true;
      orderAssignDealtContractToAssignInfoListTransfer(params).then((res) => {
        let json = res.data;
        this.isLoading = false;
        if (json.status === '200') {
          this.$message.success('分配成功');
          this.close();
          this.$router.go(-1);
        } else {

        }
      }).catch((res) => {
        this.isLoading = false;
      });
    }
  },
  mounted () {
    // this.initData();
  },
  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
